<template>
    <div class="ModalNormativa">
        <b-modal ref="modal-normativa" id="modalNormativa" size="lg" body-class="m-modal-body" :hide-footer="true" :hide-header="true" content-class="wrapper top-flashlight leftside light-xl" modal-class="rbt-modal-box share-modal" centered>
            <h5 class="title">Envie a sua Normativa.</h5>
            <h6 >Envie sua normativa personalizada para melhorar a precisão de suas consultas de <b>Parecer Técnico</b> na lei 14.133 e 13.303, <b>Artefatos</b> e <b>Researchs</b></h6>
            <button class="close-button" data-bs-dismiss="modal" @click="close">
                <i class="feather-x"></i>
            </button>
            <div class="">
                <form class="" id="formNormativa">
                    <div class="form-group">
                        <div class="" v-if="normativas.length > 0">
                            <h6>Normativa enviada:</h6>

                            <div class="box-files mt-3">
                                <div class="item-files me-2" v-for="(item, index) in normativas" :key="index">
                                    <a class="me-3" href="javascript:void(0)" @click="download(item.urlArquivo, item.dsNome)">{{item.dsNome}}</a>

                                    <button class="react-btn btn-default btn-small btn-border btn-selecionar px-2" @click="removeNormativa(item.idNorma)" type="button"><i data-v-61dd7a3d="" class="feather-x"></i></button>
                                </div>
                            </div>
                        </div>
                        

                        <template v-else>
                            <h6 for="senhaAtual">Selecione o arquivo da sua normativa (formatos aceitos .pdf,.txt e .docx)</h6>
                            <label for="fileNormativa" class="custom-file-upload ">Selecionar Arquivos</label>
                            <input type="file" id="fileNormativa" name="fileNormativa" accept=".pdf,.doc,.docx" multiple @change="onFileChange">

                            <div class="box-files mt-3" v-if="files">
                                <div class="item-files me-2" v-for="(file, index) in files" :key="index">
                                    <span class="me-3">{{file.name}}</span>
                                    <button class="react-btn btn-default btn-small btn-border btn-selecionar px-2" @click="removeFile(index)"><i data-v-61dd7a3d="" class="feather-x"></i></button>
                                </div>

                            </div>


                            <button class="btn-default bg-solid-primary w-100 mt-5" type="button" @click="enviar">Enviar</button>
                        </template>

                    </div>

                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { urlApi, avisoToast, avisoErro } from '@/config/global'
    import axios from 'axios'
    import Swal from 'sweetalert2'

    export default {
        name: 'ModalNormativa',
        data: function () {
            return {

                limiteCaracteres: 500,

                usuario: {
                    senhaAtual: null,
                    dsSenha: null,
                    dsSenhaConfirma: null,
                },

                files: [],
                normativas: [],
            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {
            liberaSalvar() {
                if (this.usuario.senhaAtual == '' || this.usuario.senhaAtual == null) {
                    return false;
                }

                if (this.usuario.dsSenha == '' || this.usuario.dsSenha == null) {
                    return false;
                }

                if (this.usuario.dsSenhaConfirma == '' || this.usuario.dsSenhaConfirma == null) {
                    return false;
                }


                return true;
            }
        },
        methods: {
            enviar() {
                let $this = this;
                const formData = new FormData();
                if (this.files.length > 0) {
                    formData.append("file", this.files[0]);

                    axios.post(`${urlApi}/Norma/post`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, } })
                        .then(res => {
                            if (res.data.success) {
                                avisoToast("Normativa registrada com sucesso.");
                                $this.load();
                            } else {
                                avisoErro("Não foi possível enviar a normativa.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data) {
                                $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                                avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                            } else {
                                avisoErro("Não foi possível enviar a normativa.");
                            }
                        });
                }
                return false;
                
            },

            load() {
                let $this = this;
                axios.get(`${urlApi}/Norma/Get`, { })
                    .then(res => {
                        if (res.data.success) {
                            $this.normativas = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                let item = res.data.data.rows[i];

                                var nomeArquivo = item.urlArquivo.split('/');
                                if (nomeArquivo.length > 0) {
                                    //item.dsNome = nomeArquivo[nomeArquivo.length - 1].slice(7);
                                    item.dsNome = nomeArquivo[nomeArquivo.length - 1];
                                }

                                $this.normativas.push(item);
                                break;
                            }
                            
                        } else {
                            avisoErro("Não foi possível carregar a normativa.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar a normativa.");
                        }
                    });
            },

            close() {
                this.$refs['modal-normativa'].hide();
            },

            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.createFile(files);
            },

            createFile(files) {
                for (var index = 0; index < files.length; index++) {
                    this.files.push(files[index]);
                }
            },

            removeFile(index) {
                this.files.splice(index, 1)
            },

            removeNormativa(idNorma) {
                let $this = this;
                let dados = { idNorma: idNorma };
                Swal.fire({
                    title: 'Tem certeza que deseja remover a normativa?',
                    text: 'Esta operação não poderá ser desfeita.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não',
                    confirmButtonColor: '#83A431',
                }).then((result) => {
                    if (result.isConfirmed) {
                        $this.remover(dados);
                    }
                })
            },

            remover(dados) {
                let $this = this;
                axios.post(`${urlApi}/Norma/Delete`, dados)
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Normativa removida com sucesso.");
                            $this.load();
                        } else {
                            avisoErro("Não foi possível remover a normativa.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível remover a normativa.");
                        }
                    });
            },

            download(urlArquivo, dsNome) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    nmArquivo = dsNome + "." + nmArquivo.split(".")[1];
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            }

        },
        created: function () {
            this.load();
        },
        watch: {
            showModal: function () {
                this.$refs['modal-normativa'].show();
                this.usuario = {
                    senhaAtual: null,
                    dsSenha: null,
                    dsSenhaConfirma: null,
                };
            },

        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
    /* MODAL ModalNormativa */
    .form-control {
        border: 1px solid #474747;
    }

    input[type="file"] {
        display: none;
    }

    .custom-file-upload {
        display: inline-block;
        padding: 6px 25px;
        cursor: pointer;
        background: linear-gradient(90deg, rgba(0, 81, 173, 1) 0%, rgba(0, 191, 81, 1) 100%);
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        color: #FFF;
    }

    .box-files {
        display: flex;
        .item-files

    {
        display: inline-block;
        padding: 5px;
        border: 1px solid #ccc;
        border-radius: 5px;
    }

    }
</style>

